import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/img/icon/calendar-outline-blue.svg'
import _imports_1 from '@/assets/img/icon/edit-box-blue.svg'
import _imports_2 from '@/assets/img/icon/delete-box-red.svg'


const _hoisted_1 = { class: "mb-6" }
const _hoisted_2 = { class: "background-grey-2 px-3 py-2 rounded-lg mb-4" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Total Kontrak: ")
const _hoisted_4 = { class: "color-blue-1 font-bold" }
const _hoisted_5 = {
  key: 0,
  class: "text-center italic color-grey-5 mt-10 mb-6 text-sm"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Anda belum menambahkan kontrak untuk partner ini, klik ")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Tambah Kontrak", -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" untuk membuat kontrak baru ")
const _hoisted_9 = [
  _hoisted_6,
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = { class: "py-10px px-16px border-bottom-white-darken-3" }
const _hoisted_11 = { class: "flex items-center justify-between" }
const _hoisted_12 = { class: "text-xl font-bold" }
const _hoisted_13 = { class: "flex items-center" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  class: "",
  src: _imports_0
}, null, -1)
const _hoisted_15 = { class: "border-right-grey-lighten-3 px-2 color-grey-5" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Tanggal Berlaku: ")
const _hoisted_17 = { class: "color-grey-5 font-bold" }
const _hoisted_18 = { class: "ml-2 green-label font-bold mt-1" }
const _hoisted_19 = { class: "lg:flex gap-2" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["onClick"]

import { getCurrentInstance, onMounted, reactive, ref } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'
import Card from 'primevue/card'
import HeaderCustom from '@/views/components/header/HeaderHjpTable.vue'
import apiUseCase from '@/usecase/apiUseCase'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'
import moment from 'moment'
import numberFormat from '@/utils/helpers/numberFormat'
import HjpConfirmationModal from '@/views/components/modal/HjpConfirmationModal.vue'
import Paginator from '@/views/components/paginator/Paginator.vue'
import ContractForm from './components/dialog/Form.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ListContract',
  setup(__props) {

const partnerEndpoint = '/management/v2/Partners'
const store = useStore()
const app = getCurrentInstance()
const {
  $toast, $strInd
} = app!.appContext.config.globalProperties
const headerTitle = ref('')
const buttonTitle = ref('Tambah Kontrak')
const searchPlaceholder = ref('Cari Disini...')
const showSearch = ref(true)
const showBtnAdd = ref(true)
const showForm = ref(false)
const selectedDataId = ref(null) as any
const router = useRouter()
const route = useRoute()
const partnerData = ref(null) as any
const dataRow = ref(null) as any
const dataSource = ref([]) as any
const showConfirmDialog = ref(false)
const filters = ref({
  search: '',
  filterField: ['trayekName'],
  pageNumber: 1,
  pageSize: 10,
  totalRecords: 0,
  custom: [['orderBy', '=', 'CreatedAt desc']] as any
})

const confirmDialogDelete = reactive({
  show: false,
  title: 'Hapus Kontrak?',
  subTitle: 'Data kontrak tersebut akan dihapus dalam sistem. Yakin hapus kontrak?',
  btnSubmitTitle: 'Hapus Kontrak',
  // imgContent: require('@/assets/img/modal-confirmation/closing-stat.svg')
})

const onSearch = (val: any) => {
  console.log('search', val)
  filters.value.search = val
  // eslint-disable-next-line no-use-before-define
  getData()
}

const showFormAct = () => {
  showForm.value = true
}

const hideFormAct = () => {
  selectedDataId.value = null
  showForm.value = false
}

const onClickBtnAdd = () => {
  console.log('add')
  // showFormAct()
  setTimeout(() => {
    router.push({
      name: 'partner-agreement-form',
      params: {
        partnerId: route.params.id
      }
    })
  }, 500)
}

const toEditForm = (data: any) => {
  dataRow.value = data
  setTimeout(() => {
    router.push({
      name: 'partner-agreement-form',
      params: {
        partnerId: route.params.id,
        id: encryptDecriptMethods.encrypt(dataRow.value.Id)
      }
    })
  }, 500)
}

const getData = async () => {
  store.dispatch('showLoading')
  await apiUseCase.get(`${partnerEndpoint}/${partnerData.value?.Id}/Agreements${returnUrlPrams(filters.value)}`).then((response) => {
    const { result, error, count } = response
    if (!error) {
      filters.value.totalRecords = count
      dataSource.value = result
    }
  })
  store.dispatch('hideLoading')
}

const onDelete = (data: any) => {
  console.log('dataDelete', data)
  if (data?.PartnerAgreementScheduleCount > 0) {
    $toast.add({
      severity: 'error',
      summary: 'Kontrak Partner gagal dihapus!',
      detail: 'Kontrak Partner yang dipilih memiliki Jam PP yang masih aktif',
      group: 'bc',
      life: 3000
    })
  } else {
    showConfirmDialog.value = true
    confirmDialogDelete.show = true
    dataRow.value = data
  }
}

const hideDialogConfirmation = () => {
  showConfirmDialog.value = false
  confirmDialogDelete.show = false
  dataRow.value = null
}

const submitFromDialog = async () => {
  store.dispatch('showLoading')
  await apiUseCase.delete(`${partnerEndpoint}/${partnerData.value?.Id}/Agreements`, dataRow.value?.Id).then((response) => {
    const { error, message } = response
    if (!error) {
      $toast.add({
        severity: 'success',
        summary: 'Kontrak Partner berhasil dihapus!',
        detail: 'Data Kontrak Partner di sistem telah berhasil dihapus',
        group: 'bc',
        life: 3000
      })
      showConfirmDialog.value = false
      confirmDialogDelete.show = false
      getData()
    } else {
      $toast.add({
        severity: 'error',
        summary: 'Kontrak Partner gagal dihapus!',
        detail: message,
        group: 'bc',
        life: 3000
      })
      showConfirmDialog.value = false
      confirmDialogDelete.show = false
    }
  })
  store.dispatch('hideLoading')
}

const onChangePage = (evt: any) => {
  filters.value.pageNumber = evt.page + 1
  getData()
}

onMounted(() => {
  partnerData.value = encryptDecriptMethods.decrypt(route.params.id)
  getData()
  store.dispatch('ui/setBreadcrumbs', [
    {
      title: 'Master Partner',
      routeName: 'master-partner'
    },
    {
      title: `${partnerData.value?.Name}`,
      routeName: 'partner-agreement'
    }
  ])
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Card), { class: "card-no-shadow wrap-hjp-data-table" }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(HeaderCustom, {
            titleHeader: headerTitle.value,
            titleButton: buttonTitle.value,
            onRedirectAdd: onClickBtnAdd,
            placeholder: searchPlaceholder.value,
            onOnSearch: onSearch,
            showSearch: showSearch.value,
            showAddBtn: showBtnAdd.value
          }, null, 8, ["titleHeader", "titleButton", "placeholder", "showSearch", "showAddBtn"])
        ])
      ]),
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("span", _hoisted_4, _toDisplayString(`${filters.value.totalRecords} Kontrak`), 1)
        ]),
        (_unref(dataSource).length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_9))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dataSource), (data) => {
          return (_openBlock(), _createElementBlock("div", { key: data }, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_12, _toDisplayString(data.TrayekName), 1),
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("div", _hoisted_15, [
                      _hoisted_16,
                      _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(moment)(data.CreatedAt).format('DD MMM YYYY')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(numberFormat)(data.PartnerAgreementScheduleCount ?? 0)) + " PP", 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", null, [
                    _createElementVNode("img", {
                      src: _imports_1,
                      alt: "edit",
                      class: "cursor-pointer mb-2 lg:mb-0",
                      style: {"width":"35px","height":"35px"},
                      onClick: ($event: any) => (toEditForm(data))
                    }, null, 8, _hoisted_20)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("img", {
                      src: _imports_2,
                      alt: "delete",
                      class: "cursor-pointer",
                      style: {"width":"35px","height":"35px"},
                      onClick: ($event: any) => (onDelete(data))
                    }, null, 8, _hoisted_21)
                  ])
                ])
              ])
            ])
          ]))
        }), 128))
      ]),
      footer: _withCtx(() => [
        (filters.value.totalRecords > 0)
          ? (_openBlock(), _createBlock(Paginator, {
              key: 0,
              rows: filters.value.pageSize,
              totalRecords: filters.value.totalRecords,
              onOnPage: onChangePage
            }, null, 8, ["rows", "totalRecords"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (showForm.value)
      ? (_openBlock(), _createBlock(ContractForm, {
          key: 0,
          show: showForm.value,
          partnerId: _unref(partnerData).Id,
          onHideDialog: hideFormAct
        }, null, 8, ["show", "partnerId"]))
      : _createCommentVNode("", true),
    (showConfirmDialog.value)
      ? (_openBlock(), _createBlock(HjpConfirmationModal, {
          key: 1,
          show: showConfirmDialog.value,
          title: confirmDialogDelete?.title,
          subTitle: confirmDialogDelete?.subTitle,
          btnSubmitTitle: confirmDialogDelete?.btnSubmitTitle,
          onHideDialog: hideDialogConfirmation,
          onOnSubmit: submitFromDialog
        }, null, 8, ["show", "title", "subTitle", "btnSubmitTitle"]))
      : _createCommentVNode("", true)
  ]))
}
}

})